<div class="order-information-container">
  <div class="row">
    <div class="col-lg-12">
      <lidl-lib-order-fe-title [titleText]="'modeso_order_order-checkout_order-saved' | injectedText | async">
      </lidl-lib-order-fe-title>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-7">
      <lidl-lib-order-fe-sub-title [subTitleText]="'modeso_order_order-checkout_thank-you' | injectedText | async">
      </lidl-lib-order-fe-sub-title>
      <modeso-short-email-details
      *ngIf="postedSuccessfully"
        [deliveryDate]="deliveryDate ? deliveryDate : (order$ | async)?.deliveryOption?.deliveryDate"
        [orderId]="(order$ | async)?._id" [language]="language">
      </modeso-short-email-details>
      <div class="row">
        <div [ngClass]="{ 'show-component': true }" class="col-lg-7 compact-component">
          <ng-content select="[address-content]"></ng-content>
        </div>
        <div [ngClass]="{ 'show-component': true }" class="col-lg-5 compact-component">

          <ng-content select="[payment-content]"></ng-content>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'show-component': true }" class="col-lg-4 pull-right compact-component">
      <ng-content select="[cart-content]"></ng-content>
    </div>
  </div>
</div>